// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Constants
import { DEFAULT_MODULE_SIZE_FILTERS } from '../../constants';
// NgRx actions
import { setModuleFilters } from './filters.action';
export const filters = createReducer(DEFAULT_MODULE_SIZE_FILTERS, on(setModuleFilters, (state, action) => {
    return { ...action.filters };
}));
